export const CanUseWebP = (ignoreDev = false) => {
  // SSR: на сервере нет canvas, проверить браузер нечем. Раньше здесь был
  // false, и сервер слал в API `x-webp-token: 0` (src/api/graphql.ts) —
  // баннеры слайдера и прочие картинки из SSR приходили НЕ в webp, а через
  // dehydrate эти же данные доставались и клиенту (повторно он их не
  // запрашивает). Теперь считаем, что webp поддерживается: это верно для
  // всех целевых браузеров (Chrome/Edge, Firefox 65+, Safari 14+ на
  // iOS 14+/macOS 11+) и для поисковых ботов. Исключение — Safari 14 на
  // macOS 10.15 (webp там зависит от ОС), определить его по запросу нельзя.
  // Аварийный выключатель: SSR_WEBP=0 в env сервера вернёт старое поведение.
  // ignoreDev=false (dev-ветка «не webp вне delikateska.ru») — как и в
  // браузере на localhost: false.
  if (typeof window === 'undefined') {
    if (!ignoreDev) return false;
    const flag =
      typeof process !== 'undefined' && process.env
        ? String(process.env.SSR_WEBP ?? '').trim()
        : '';
    return flag !== '0';
  }
  const name = `AppCanUseWebP${ignoreDev ? 'Production' : 'DEV'}`;

  if (typeof window[name] === 'undefined') {
    window[name] = CanUseWebPForce(ignoreDev);
  }

  return window[name];
};

export const CanUseWebPForce = (ignoreDev = false) => {
  if (
    ignoreDev === false &&
    location.href.indexOf('delikateska.ru') === -1
  ) {
    return false; // For dev build
  }

  const elem = document.createElement('canvas');

  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  }

  return false;
};

export const CheckIsBot = function () {
  if (typeof navigator === 'undefined') return false;
  const botPattern =
    '(googlebot/|bot|Chrome-Lighthouse|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
  const re = new RegExp(botPattern, 'i');
  const userAgent = navigator.userAgent;

  if (re.test(userAgent)) {
    return true;
  }

  return false;
};

export const IsPrerender = function () {
  return (
    typeof window !== 'undefined' && location.href.includes('prerender')
  );
  // return location.href.indexOf('prerender') != -1;
};

export const IsMobile = function () {
  if (typeof window === 'undefined') return false;
  const innerWidth = window.innerWidth;

  return innerWidth < 768;
};

export const CanUseChatBot = function () {
  return !IsPrerender() && !CheckIsBot() && !IsMobile(); // Не бот, не пререндер и не мобилка
};
